module.exports = __webpack_public_path__ + "static/media/add_to_cart_icon.bf800490.svg";